export var DISPLAY_WIDTH = {
  MOBILE: 768,
  TABLET: 1024
};